import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Córdoba',
  text: '"Llevaba años sintiéndome culpable sin entender por qué. En dos semanas de trabajar con el método entendí que esa culpa no era mía. Era de mi árbol. Nunca nadie me lo había explicado así."'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  text: '"El Tomo 2 — El Espejo de la Madre — me cambió la vida. Por primera vez entendí la relación con mi mamá sin culparla ni culparme. Solo ver. Solo entender. Fue liberador."'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Buenos Aires',
  text: '"Ya había hecho terapia, constelaciones y coaching. El Código de la Hija Libre fue lo que conectó todo. El método es diferente. Más profundo. Más honesto."'
}];
export function TestimonialsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-316">
      <div className="container mx-auto max-w-5xl" data-id="element-317">
        <div ref={ref1} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-318">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className="bg-[#2D1B1B] border border-[#C9A96E]/20 rounded-2xl p-6 flex flex-col shadow-lg" data-id="element-319">
              <div className="flex items-center gap-3 mb-4" data-id="element-320">
                <div className="w-10 h-10 rounded-full bg-[#C9A96E]/20 border border-[#C9A96E]/30 flex items-center justify-center text-[#C9A96E] font-bold text-sm" data-id="element-321">
                  {t.initials}
                </div>
                <div data-id="element-322">
                  <div className="flex text-[#C9A96E] text-sm mb-0.5" data-id="element-323">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="text-[#F5ECD7] font-bold text-sm" data-id="element-324">
                    {t.name}{' '}
                    <span className="text-[#D4A5A5] font-normal" data-id="element-325">
                      — {t.location}
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-[#FAF3E8] text-sm leading-relaxed italic" data-id="element-326">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}